import { API_UPLOAD_PATH } from "../../../../_emywork/helpers/UIHelper";

export const WALLET_CONTEXT = "wallets";
export const UPLOAD_PATH = `${API_UPLOAD_PATH}/${WALLET_CONTEXT}`;

export const WALLET_CONTEXT_TITLE = {
  singular: "WALLET",
  plural: "WALLETS",
};

//deposits
export const DEPOSITS_CONTEXT = "deposits";
export const DEPOSITS_UPLOAD_PATH = `${API_UPLOAD_PATH}/${WALLET_CONTEXT}`;

export const DEPOSITS_CONTEXT_TITLE = {
  singular: "DEPOSIT",
  plural: "DEPOSITS",
};
//transactions
export const TRANSACTIONS_CONTEXT = "transactions";

export const TRANSACTIONS_CONTEXT_TITLE = {
  singular: "TRANSACTION",
  plural: "TRANSACTIONS",
};
